import styled from "@emotion/styled";

import { withDataTest } from "../utilities";

// DEPRECATED: this is only used to support the old school activity types.

const StyledActivityHeader = styled.div`
  width: 100%;
  background-color: #009fda; // TODO: Use colors from player theme
  color: #fff;
  padding: 24px 64px;

  & > h3 {
    font-size: 30px;
    line-height: 36px;
    font-weight: bold;
    margin: 16px 0 16px 0;
  }
`;

export const ActivityHeader = withDataTest(StyledActivityHeader, "activity-header");
